import React, { useEffect } from 'react';

const SmartEditorInputArea: React.FC = () => {
  useEffect(() => {
    // smart_editor2_inputarea.html의 내용을 동적으로 로드
    const loadInputArea = async () => {
      try {
        const response = await fetch('/static/smarteditor/smart_editor2_inputarea.html');
        const html = await response.text();
        document.body.innerHTML = html;
        
        // 필요한 스크립트들을 동적으로 로드
        const scripts = [
          '/static/smarteditor/js/lib/jindo2.all.js',
          '/static/smarteditor/js/lib/jindo_component.js',
          '/static/smarteditor/js/service/SE2M_Configuration.js',
          '/static/smarteditor/js/smarteditor2.js'
        ];
        
        for (const scriptSrc of scripts) {
          const script = document.createElement('script');
          script.src = scriptSrc;
          script.async = true;
          document.head.appendChild(script);
        }
      } catch (error) {
        console.error('Error loading SmartEditor input area:', error);
      }
    };
    
    loadInputArea();
  }, []);

  return null;
};

export default SmartEditorInputArea;
